import { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import type { Paywall } from "@circle-react/types";
import type { PaywallPrice } from "@circle-react/types/PaywallPrice";
import { getPaywallPrice } from "../helpers/paywallPrices";
import type { CheckoutFormValuesProps } from "../types/CheckoutFormValuesProps";

export interface UseCheckoutSelectedPriceReturnProps {
  getSelectedPrice: () => PaywallPrice;
  isSelectedPrice: (price: PaywallPrice) => boolean;
  setSelectedPrice: (priceId: number) => void;
}

export const useCheckoutSelectedPrice = (
  paywall: Paywall,
  previewCheckout: () => void,
): UseCheckoutSelectedPriceReturnProps => {
  const { setValue, watch } = useFormContext<CheckoutFormValuesProps>();

  const setSelectedPrice = useCallback(
    (priceId: number) => {
      setValue("paywall_price_id", priceId);
      previewCheckout();
    },
    [setValue, previewCheckout],
  );

  const getSelectedPrice = useCallback(() => {
    const paywallPriceId = watch("paywall_price_id");
    return getPaywallPrice(paywall, paywallPriceId);
  }, [paywall, watch]);

  const isSelectedPrice = useCallback(
    (price: PaywallPrice) => {
      const selectedPrice = getSelectedPrice();
      return selectedPrice?.id === price.id;
    },
    [getSelectedPrice],
  );

  return { getSelectedPrice, setSelectedPrice, isSelectedPrice };
};
